export const state = () => ({
  error: "test",
});

export const actions = {
  set({commit}, error) {
    commit('SET', error);
  },
  clear({commit}) {
    commit('CLEAR');
  },
};

export const mutations = {
  SET(state, error) {
    state.error = error;
  },
  CLEAR(state, error) {
    state.error = ""
  },
};

export const getters = {
  getError: (state) => {
    return state.error;
  },
};